import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';

export type MenuItem = {
  title: string;
  link: string;
  message: string;
  isActive: boolean;
  items: MenuItem[];
};

export type DxDiagnosisMenuResponse = MenuItem[];

export const dxDiagnosisMenuApiClient = {
  index: async (): Promise<ApiResult<DxDiagnosisMenuResponse>> => {
    return await axiosClient.get('/company/dx-diagnosis-menus');
  },
};
